import { Menu, MenuItem } from '@blueprintjs/core';
import React, { Component } from 'react';

class MenuExceptionTrip extends Component {

  render() {
    const status = 'Complete,Noload,Canceled,Void';
    const canceledStatus = 'Canceled';
    const isReservedByAnotherUser = this.props.reservedByUser ? true : false;

    return (
      //Reservation and resolving
      <Menu>
        {this.props.reservedByMe ?
          <>
            <MenuItem icon="small-cross" text="Resolve Exception" id={'isDialogClearException'}
              onClick={(e) => this.props.handleConfirmedMenuClick(e)} />
            <MenuItem icon="ban-circle" text="Unreserve Exception" id={'isDialogCancelReservation'}
              onClick={(e) => { this.props.handleConfirmedMenuClick(e, this.props.exceptionId) }} />
          </>
          :
          <>
          <MenuItem icon="layer" disabled={isReservedByAnotherUser} text="Reserve Exception" id={'isDialogReserveException'}
            onClick={(e) => { this.props.handleConfirmedMenuClick(e, this.props.exceptionId) }} />
          <MenuItem icon="layers" disabled={isReservedByAnotherUser} text="Reserve all Exceptions for this trip" id={'isDialogReserveAllExceptions'}
          onClick={(e) => { this.props.handleConfirmedMenuClick(e, this.props.exceptionId, this.props.tripNumber) }} />
          </>
        }

        <Menu.Divider />

        {!status.includes(this.props.tripStatus) ?
          <>
            <MenuItem icon="mobile-phone" text="Send SMS" id={'isDialogSendSms'} onClick={this.props.handleConfirmedMenuClick} />
            <MenuItem icon="delete" text="Remove Provider" id={'isDialogRemoveProvider'} onClick={this.props.handleConfirmedMenuClick} />
          </>
          : null}

        <MenuItem icon="arrow-right" text="Emulate Events" id={'isOverlayEmulateEvents'} onClick={this.props.handleConfirmedMenuClick} />
        {!status.includes(this.props.tripStatus) ?
          <MenuItem icon="confirm" text="Confirm Provider" id={'isOverlayConfirmProvider'} onClick={this.props.handleConfirmedMenuClick} />
          : null
        }
        {!canceledStatus.includes(this.props.tripStatus) ?
          <MenuItem icon="undo" text="Cancel Trip" id={'isOverlayConfirmTripCancellation'} onClick={this.props.handleConfirmedMenuClick} />
          : null
        }
      </Menu>
    );
  }
}

export default MenuExceptionTrip;
